"use client";

import Link from "@components/Link";
import { useMarket } from "@features/market/useMarket";
import type { ReactNode } from "react";

const ProductListMoreLink = ({
  slug,
  children,
}: {
  slug?: string;
  children: ReactNode;
}) => {
  const locale = useMarket().siteLocale;

  if (!slug || !children) return null;

  return (
    <Link
      locale={locale}
      href={slug}
      className="mt-1 text-base whitespace-nowrap underline"
    >
      {children}
    </Link>
  );
};

ProductListMoreLink.displayName = "ProductListMoreLink";

export default ProductListMoreLink;
